import React from 'react'
import NavBar from '../NavBar'
import { MainTitle, Paragraf } from '../Styled'
import { HeroImg, HeroInner, HeroLeft, HeroSection } from './OmOs.styled'
import Wave from '../svgfiles/Wave'
import CTAUP from '../blocks/CTAUp'
import Features from '../blocks/Features'
import KontaktFormular from '../blocks/KontaktFormular'
import Footer from '../blocks/Footer'
import placeHolderImg from '../images/app_mockups_showcase.png'
import Colab from '../images/Collab.jpg';


const CARDS = [
    {
        title: 'Appudvikling',
        source: placeHolderImg,
        text: 'Udvikling af Native App og software.',
        id: 0,
    },
    {
        title: 'Webudvikling',
        source: placeHolderImg,
        text: 'Udvikling af software på et websted.',
        id: 1,
    },
    {
        title: 'Vedligeholdelse',
        source: placeHolderImg,
        text: 'Hold din App optimeret med vedligeholdelse.',
        id: 2,
    },
    {
        title: 'Opdatering',
        source: placeHolderImg,
        text: 'Opdater din CMS baserede App eller hjemmeside',
        id: 3,
    },
]
const OmOs = () => {
    return (
        <>
            <HeroSection>
                <NavBar />
                <HeroInner>
                    <HeroLeft>
                        <MainTitle>
                            Tal med os
                        </MainTitle>
                        <Paragraf>
                            Noaly er en softwareudviklings- og IT-konsulentpartner til startups og scale-ups. Vi leverer udviklingstjenester i fuld cyklus for at hjælpe virksomheder med at skalere ved at bruge teknologiske løsninger, forbedre kundeoplevelsen og skabe nye produkter og interne processer.
                        </Paragraf>
                    </HeroLeft>
                    <div>
                        <HeroImg src={Colab} alt="Samarbejde" />
                    </div>
                    <Wave />
                </HeroInner>
            </HeroSection>
            <KontaktFormular id='formular' />
            <CTAUP
                title='Vi er et service firma'
                body='Vi ved, at det kan være en risikabel, kreativ bestræbelse at bygge en app, som folk elsker. Derfor laver vi ikke antagelser, vi fjerner dem. Vi opdager, strategiserer, designer, udvikler, brander og lancerer virksomheder i verden.'
                btn='Se cases'
                photo={placeHolderImg}
                alt='Placeholder'
            />
            <Features
                CARDS={CARDS}
                title='Hvordan kan vi hjælpe dig?'
                body='
                Noaly er et tværfagligt kreativt bureau på Amager, København. Vores mål er at servicere enkeltpersoner og teams, der starter en ny virksomhed eller et projekt.'
            />
            <Footer />
        </>
    )
}

export default OmOs